import React from "react";
import UserList from "../../Components/UserList";

const Students = () => {
  return <UserList role="student" roleLabel="Students" />;
};

export default Students;
